"use client";
import { ConfigTypes } from "@/api/AppApi/common-interfaces/api-enums";
import { IBlogCategories } from "@/api/AppApi/services/home/interfaces/ICategory";
import BlogCategoryGrid from "./BlogCategoryGrid";
import BlogCategoryCarousel from "./BlogCategoryCarousel";
import Separator from "../../lib/Separator";
import { carouselSpeed } from "@/utils/functions/functions";
import { useTranslation } from "@/hooks/localization/useTranslations";

const BlogCategories = (props: IBlogCategories) => {
  const t = useTranslation();
  const speed = carouselSpeed(props.configurations?.customize?.interval);
  const targetUrl = props.configurations?.target_url;
  return (
    <>
      <Separator
        startLabel={props.configurations?.title!}
        endLabel={
          targetUrl
            ? { label: t.view_all, href: targetUrl }
            : undefined
        }
      />
      {props.configurations?.type === ConfigTypes.grid ? (
        <BlogCategoryGrid {...props} showCategoryImage={true} />
      ) : (
        <BlogCategoryCarousel {...props} speed={speed} showCategoryImage={true} />
      )}
    </>
  );
};

export default BlogCategories;
